export default __webpack_public_path__ + "static/media/36I-102610_-15499_0.cc1a17ab.jpg";